<tt-side-drawer-container *ngIf="!!page" [class.doc-arc--mobile]="'mobile' | mediaQuery" [style.--doc-arc-bottom-sheet-height]="bottomSheetMinHeight">
    <tt-document-viewer-legacy [ttModel]="('mobile' | mediaQuery) ? mobileViewerPage : page" ttShowDocument="true"></tt-document-viewer-legacy>

    <ng-container *ngIf="!('mobile' | mediaQuery)">
        <tt-button class="drawer-toggle" ttText="h_info" (ttClick)="drawer.toggle()"></tt-button>
        <tt-side-drawer #drawer ttRememberId="w_docarc.infodrawer" ttPersistLocalOnly="false" ttInitialState="open" ttDisableClose ttPosition="end" ttWidth="30rem" ttMode="side">
            <tt-doc-arc-information [page]="page" [documentCategories]="documentCategories"></tt-doc-arc-information>
        </tt-side-drawer>
    </ng-container>

    <tt-bottom-sheet *ngIf="'mobile' | mediaQuery" [ttMinHeight]="bottomSheetMinHeight">
        <tt-doc-arc-information [page]="page" [documentCategories]="documentCategories"></tt-doc-arc-information>
    </tt-bottom-sheet>
</tt-side-drawer-container>
